// @flow

import React from 'react';
import { isMobile } from 'react-device-detect';

import { filters, body } from 'core/config';
import { searchJobs as t } from 'helpers/translation';
import BtnRounded from 'components/BtnRounded';
import Filter from 'components/Filter';

type Props = {
  showFilters: boolean,
  counts: any,
  search: any,
  pushToSearch: Function,
  updateSearch: Function,
  toggleVisibility: Function,
  urlSearch: string
};

export default ({ showFilters, counts, search, pushToSearch, updateSearch, toggleVisibility, urlSearch }: Props) => {
  const handleClick = () => {
    body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';

    toggleVisibility('filters');
  };

  const clearFilters = () => {
    updateSearch({});
    body.style.overflow = 'auto';
  };

  const filtersWithoutLocales = filters.filter(item => item.counts_param !== 'job_languages')

  const renderDesktop = () => (
    <div className={`company-search__wrapper${showFilters ? ' active-desktop' : ''}`}>
      <div className="company-search__desktop company-search__inner">
        {filtersWithoutLocales.map(filter => (
          <Filter
            key={filter.label}
            filter={filter}
            counts={counts}
            search={search}
            limit={filter.limit}
            pushToSearch={pushToSearch}
          />
        ))}
      </div>
    </div>
  );

  const renderMobile = () => (
    <div className={`company-search__wrapper${showFilters ? ' active-mobile' : ''}`}>
      <div className="company-search__mobile">
        <div className="company-search__buttons">
          <BtnRounded
            iconBefore='settings'
            text={t.btn.show_filters}
            classes={`btn_shadow${showFilters ? ' active' : ''}`}
            type='primary'
            handleClick={handleClick}
          />
          {urlSearch && <BtnRounded
            handleClick={clearFilters}
            text={t.btn.reset_filters}
            iconBefore="redo"
            type='default'
          />}
        </div>
        <div className="company-search__inner">
          {filtersWithoutLocales.map(filter => (
            <Filter
              key={filter.label}
              filter={filter}
              counts={counts}
              search={search}
              limit={filter.limit}
              pushToSearch={pushToSearch}
            />
          ))}
        </div>
        <button type="button" className="btn btn_primary mobile-filter__button" onClick={handleClick}>{t.btn.apply_filters}</button>
      </div>
    </div>
  );

  return isMobile ? renderMobile() : renderDesktop();
};
